import Cookies from "js-cookie";
import axiosClient from "./ApiInstance";
import { CookiesName } from "./common";

const handleAuthFailure = (error) => {
  const status = error?.response?.status;
  if (status === 401) {
    Cookies.remove(CookiesName, { path: "/" });
  }
};

export const GET = async (url, data) => {
  try {
    const response = await axiosClient.get(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("GET request failed:", error);
    handleAuthFailure(error);
    // window.location.href = "/";
    throw error;
  }
};

export const POST = async (url, data) => {
  try {
    const response = await axiosClient.post(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("POST request failed:", error);
    handleAuthFailure(error);
    // window.location.href = "/";
    throw error;
  }
};

export const PATCH = async (url, data) => {
  try {
    const response = await axiosClient.patch(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("PATCH request failed:", error);
    handleAuthFailure(error);
    // window.location.href = "/";
    throw error;
  }
};

export const PUT = async (url, data) => {
  try {
    const response = await axiosClient.put(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("PUT request failed:", error);
    handleAuthFailure(error);
    // window.location.href = "/";
    throw error;
  }
};

export const DELETE = async (url) => {
  try {
    const response = await axiosClient.delete(
      process.env.REACT_APP_BASE_URL + url,
    );
    return response.data;
  } catch (error) {
    console.error("DELETE request failed:", error);
    handleAuthFailure(error);
    // window.location.href = "/";
    throw error;
  }
};

// Download Files
// export const DownloadFiles = async (path, file_name = "", type = ".txt") => {
//   try {
//     const response = await axiosClient.get(
//       process.env.REACT_APP_BASE_URL + path,
//       {
//         responseType: "blob",
//         // params: data,
//       }
//     );

//     const url = await window.URL.createObjectURL(new Blob([response.data]));
//     const link = await document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `${file_name}${type}`);
//     document.body.appendChild(link);
//     link.click();
//     link.parentNode.removeChild(link);

//     // return response.data;
//   } catch (error) {
//     console.error(error);
//     // handleAuthFailure(error);
//     // window.location.href = "/";
//   }
// };

export const DownloadFiles = async (
  path,
  type = ".txt",
  fileName = "download",
) => {
  try {
    const response = await axiosClient.get(
      process.env.REACT_APP_BASE_URL + path,
      {
        responseType: "blob",
      },
    );

    // Extract filename from Content-Disposition header
    // const contentDisposition = response.headers["content-disposition"];
    const contentDisposition = response.headers["Content-Disposition"];

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch.length === 2) {
        fileName = fileNameMatch[1];
      }
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.${type}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

    // Clean up and remove the object URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the file:", error);
    // Handle error as needed, e.g., redirect or show a message
  }
};
